import {registry} from '../modules/registry';

export function attachModuleToEl(moduleName, el, cfg) {
    // an option hash is always provided to free the module code from checking for its existence
    const moduleObject = registry.get(moduleName);

    // If a function is returned, then we assume that this is the module destroy function.
    // We attach it to the node, this way, we may be able to retrieve it when the node is destroyed.
    // An example where it is required is when a module is initialized when a modal is opened, then it
    // needs to be destroyed when the modal is closed, otherwise some memory leaks will occurs.
    const destroyFn = moduleObject(el, cfg || {});

    el.hop = el.hop || [];
    el.hop.push({
        id: moduleName,
        destroy: destroyFn,
    });
}
